export default __webpack_public_path__ + "static/media/user-icon.342012b7.svg";